import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import InputUserData from "../views/InputUserDetail/InputUserData.vue"
import ConfirmUserData from "../views/InputUserDetail/confirmUserData.vue"
import SendCode from "../views/SendDigitCode/SendCode.vue"
import ResendCode from "../views/SendDigitCode/ResendCode.vue"
import TakePhotoPrepare from "../views/CapturePhoto/TakePhotoPrepare.vue"
import TakePhoto from "../views/CapturePhoto/TakePhoto.vue"
import VideoDetail from "../views/CaptureVideo/VideoDetail.vue"
import TakeVideo from "../views/CaptureVideo/TakeVideo.vue"
import ValidEmail from "../views/ValidEmail.vue"
import ConfirmEmail from "../views/ConfirmEmail.vue"
import RedirectSVID from "../views/RedirectSVID"
import Howdoesitwork from "../views/Howdoesitwork.vue"
import LoginSVID from "../views/LoginSVID.vue"

import VerifyComponent from "../views/Verify/Verify.vue";
import VerifyStartComponent from "../views/Verify/01-Start.vue";
import VerifyIDTypeComponent from "../views/Verify/02-IDType.vue";
import VerifyCaptureComponent from "../views/Verify/03-Capture.vue";
import VerifyReviewComponent from "../views/Verify/04-Review.vue";
import VerifyCompletedComponent from "../views/Verify/05-Completed.vue";
import VerifyPrivacyComponent from "../views/Verify/06-privacy.vue";
import ExistSidvComponent from "../views/Verify/ExistingSIDV.vue";
import CompleteExistComponent from "../views/Verify/CompleteExist.vue";
import VerifyCaptureFaceComponent from "../views/Verify/07-Capture_face.vue"
import HandleError from "../views/Verify/08-Handle_error.vue"

Vue.use(VueRouter);

const routes = [{
        path: "/home",
        name: "Home",
        component: Home,
    },
    {
        path: "/",
        name: "Verify",
        component: VerifyComponent,
        children: [{
            path: "",
            name: "VerifyGetStarted",
            component: VerifyStartComponent
        }, {
            path: "/idtype",
            name: "VerifyIDType",
            component: VerifyIDTypeComponent
        }, {
            path: "/capture",
            name: "VerifyCapture",
            component: VerifyCaptureComponent
        }, {
            path: "/review",
            name: "VerifyReview",
            component: VerifyReviewComponent
        }, {
            path: "/completed",
            name: "VerifyCompleted",
            component: VerifyCompletedComponent
        },  {
            path: "/privacypolicy",
            name: "PrivacyPolicy",
            component:VerifyPrivacyComponent
        },  {
            path: "/existsidv",
            name: "ExistSIDV",
            component:ExistSidvComponent
        },  {
            path: "/completeexist",
            name: "CompleteExist",
            component:CompleteExistComponent
        },
        {
            path: "/captureface",
            name: "VerifyCaptureFace",
            component: VerifyCaptureFaceComponent
        }
        ,{
            path: "/handleDialog",
            name: "HandleError",
            component: HandleError,
        }
    ]
    },
    {
        path: "/InputUserData",
        name: "InputUserData",
        component: InputUserData,
    },
    {
        path: "/ConfirmUserData",
        name: "ConfirmUserData",
        component: ConfirmUserData,
    },
    {
        path: "/SendCode",
        name: "SendCode",
        component: SendCode,
    },
    {
        path: "/TakePhotoPrepare",
        name: "TakePhotoPrepare",
        component: TakePhotoPrepare,
    },
    {
        path: "/TakePhoto",
        name: "TakePhoto",
        component: TakePhoto,
    },
    {
        path: "/ValidEmail",
        name: "ValidEmail",
        component: ValidEmail,
    },
    {
        path: "/ConfirmEmail",
        name: "ConfirmEmail",
        component: ConfirmEmail,
    },
    {
        path: "/RedirectSVID",
        name: "RedirectSVID",
        component: RedirectSVID,
    },
    {
        path: "/ResendCode",
        name: "ResendCode",
        component: ResendCode,
    },
    {
        path: "/Howdoesitwork",
        name: "Howdoesitwork",
        component: Howdoesitwork,
    },
    {
        path: "/LoginSVID",
        name: "LoginSVID",
        component: LoginSVID,
    },
    {
        path: "/VideoDetail",
        name: "VideoDetail",
        component: VideoDetail,
    },
    {
        path: "/TakeVideo",
        name: "TakeVideo",
        component: TakeVideo,
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;